import * as React from "react";
import "./datagrid.scss";
import DataTable from "react-data-table-component";
import DataGridPagination from "./DataGridPagination";
// import TableFilters from './TableFilters';

interface Pagination {
  results: object[];
  page?: number;
  limit?: number;
  totalPages?: number;
  totalResults?: number;
  startIndex?: number;
  endIndex?: number;
}

interface IDataGrid {
  columns: any;
  data: Pagination;
  FilterSubHeader?: boolean;
  planData?: any;
  viewData?: any;
  filterByDate?: any;
  filterData?: any;
  setFilterData?: any;
  noTableHead?: boolean;
  subHeaderComponent?: any;
  selectableRows?: any;
  onSelectedRowsChange?: any;
  pagination?: any;
}

/**
 * Data Grid Common Reusable Component
 *
 * @param {{ columns: any; data: any; FilterSubHeader: any; planData: any; viewData: any; filterByDate: any; filterData: any; setFilterData: any; noTableHead: any; }} {
    controlId, columns, data, FilterSubHeader, planData, viewData, filterByDate, filterData, setFilterData, noTableHead
}
 * @returns {*}
 */

const DataGrid: React.FC<IDataGrid> = ({
  columns,
  data,
  FilterSubHeader,
  //   planData,
  //   viewData,
  //   filterByDate,
  //   filterData,
  //   setFilterData,
  subHeaderComponent,
  selectableRows,
  onSelectedRowsChange,
  pagination = true,
}) => {
  const customSortIcon = (
    <div className='sortIconMain d-flex align-items-center flex-column'>
      <span className='sortIconUp'></span>
      <span className='sortIconDown'></span>
    </div>
  );
  return (
    <div className='dataGridListMain'>
      <DataTable
        columns={columns}
        data={data.results}
        defaultSortAsc={false}
        sortIcon={customSortIcon}
        onSort={(column, direc) => {
          const getColId = window.document.querySelector(`[data-sort-id='${column.id}']`);
          switch (direc) {
            case "asc":
              getColId?.classList.add("sortAsc");
              break;
            case "desc":
              getColId?.classList.add("sortDesc");
              break;
            default:
              break;
          }
        }}
        className='dataTableCover mt-1'
        fixedHeader
        responsive
        subHeader={FilterSubHeader}
        subHeaderComponent={subHeaderComponent}
        // subHeaderComponent={
        //   <TableFilters
        //     planData={planData}
        //     viewData={viewData}
        //     filterByDate={filterByDate}
        //     filterData={filterData}
        //     setFilterData={setFilterData}
        //   />
        // }
        pagination={pagination}
        paginationPerPage={20}
        // noTableHead={noTableHead}
        paginationComponent={() => (
          <DataGridPagination
            totalPages={data.totalPages}
            totalResults={data.totalResults}
            page={data.page}
            startIndex={data.startIndex}
            endIndex={data.endIndex}
          />
        )}
        selectableRows={selectableRows}
        onSelectedRowsChange={onSelectedRowsChange}
      />
    </div>
  );
};

export default DataGrid;
